var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M22.867 11.776C20.796 7.734 16.695 5 12 5 7.305 5 3.203 7.736 1.133 11.776c-.177.35-.177.764 0 1.115C3.204 16.932 7.305 19.667 12 19.667c4.695 0 8.797-2.737 10.867-6.776.177-.35.177-.765 0-1.115zM12 17.833a5.5 5.5 0 110-11 5.5 5.5 0 01.005 11H12zm0-9.166a3.644 3.644 0 00-.967.144 1.828 1.828 0 01-2.555 2.556A3.659 3.659 0 1012 8.667z"
  }))));
}

export default SvgEye;